import { render, staticRenderFns } from "./StockTake.vue?vue&type=template&id=5f3519c4&scoped=true&lang=pug&"
import script from "./StockTake.vue?vue&type=script&lang=js&"
export * from "./StockTake.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3519c4",
  null
  
)

export default component.exports